export default class CreateGroupModalController {
  static $inject = ['$scope'];

  owner: any;
  group: any;
  name: string;
  private $close: any;

  constructor($scope) {
    this.group = $scope.owner.modelFromForm_groups();
    if ($scope.name) {
      this.group.name = $scope.name;
    }

    if ($scope.existingGroup) {
      this.group.name = $scope.existingGroup.name;
    }
  }

  createGroup() {
    this.$close(this.group);
  }
}
